import { Commands, Downloads, Installation } from '@pages/Cli/components';
import Styles from '../../Styles.module.scss';
import { getBrandDomain } from '../../../../common/utils/getBrandDomain';

export function CLI() {
    return (
        <>
            <Installation />

            <QuickStart />

            <Commands />

            <Downloads />
        </>
    );
}

function QuickStart() {
    const brandDomain = getBrandDomain();
    return (
        <div className={Styles.Section}>
            <h2 className={Styles.SectionTitle}>Quick Start</h2>
            <p className={Styles.SectionDescription}>
                Get your local application online in three steps.
            </p>

            <div className={Styles.QuickStartGrid}>
                <div className={Styles.QuickStartCard}>
                    <div className={Styles.QuickStartStep}>
                        <div className={Styles.QuickStartNumber}>1</div>
                        <div className={Styles.QuickStartTitle}>Authenticate</div>
                    </div>
                    <p className={Styles.QuickStartDescription}>
                        Log in to ModelPark using your account credentials or API token.
                    </p>
                    <div className={Styles.CodeBlock}>
                        <code>modelpark login</code>
                    </div>
                </div>

                <div className={Styles.QuickStartCard}>
                    <div className={Styles.QuickStartStep}>
                        <div className={Styles.QuickStartNumber}>2</div>
                        <div className={Styles.QuickStartTitle}>Run your app</div>
                    </div>
                    <p className={Styles.QuickStartDescription}>
                        Start your app and create a tunnel in one step. The port is auto-detected for known frameworks.
                    </p>
                    <div className={Styles.CodeBlock}>
                        <code>modelpark run --name myapp -- streamlit run app.py</code>
                    </div>
                </div>

                <div className={Styles.QuickStartCard}>
                    <div className={Styles.QuickStartStep}>
                        <div className={Styles.QuickStartNumber}>3</div>
                        <div className={Styles.QuickStartTitle}>Access your app</div>
                    </div>
                    <p className={Styles.QuickStartDescription}>
                        Your app is live. Open the remote URL to access it from anywhere.
                    </p>
                    <div className={Styles.CodeBlock}>
                        <code>{`https://myapp.${brandDomain}`}</code>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: 32 }}>
                <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 16 }}>REST API Quick Start</div>
                <div className={Styles.QuickStartGrid}>
                    <div className={Styles.QuickStartCard}>
                        <div className={Styles.QuickStartStep}>
                            <div className={Styles.QuickStartNumber}>1</div>
                            <div className={Styles.QuickStartTitle}>Authenticate</div>
                        </div>
                        <p className={Styles.QuickStartDescription}>
                            Log in to ModelPark using your account credentials or API token.
                        </p>
                        <div className={Styles.CodeBlock}>
                            <code>modelpark login</code>
                        </div>
                    </div>

                    <div className={Styles.QuickStartCard}>
                        <div className={Styles.QuickStartStep}>
                            <div className={Styles.QuickStartNumber}>2</div>
                            <div className={Styles.QuickStartTitle}>Serve your API</div>
                        </div>
                        <p className={Styles.QuickStartDescription}>
                            Expose your REST API with API key authentication enabled.
                        </p>
                        <div className={Styles.CodeBlock}>
                            <code>modelpark serve --name myapi --port 8000 --type api</code>
                        </div>
                    </div>

                    <div className={Styles.QuickStartCard}>
                        <div className={Styles.QuickStartStep}>
                            <div className={Styles.QuickStartNumber}>3</div>
                            <div className={Styles.QuickStartTitle}>Call your API</div>
                        </div>
                        <p className={Styles.QuickStartDescription}>
                            Use your API key to make authenticated requests from anywhere.
                        </p>
                        <div className={Styles.CodeBlock}>
                            <code style={{ fontSize: '0.85em' }}>{`curl https://myapi-proxy.${brandDomain}/health -H "X-ModelPark-Key: YOUR_KEY"`}</code>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: 24, fontSize: 14, opacity: 0.7 }}>
                Or run <code style={{ color: '#4abe2f' }}>modelpark</code> with no arguments for an interactive guided experience, or add <code style={{ color: '#4abe2f' }}>--type api</code> for REST APIs.
            </div>
        </div>
    );
}
